/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMCartViewPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

export const getGTMCartViewEventData = async (payload: GTMCartViewPayload) => {
	const { cart: _cart, storeName, orgName, orgId, orderItemListRows = [] } = payload;
	const { grandTotal = 0, grandTotalCurrency = '' } = _cart;
	const hcl_account = orgId ? orgName : null;
	const cart = { grandTotal, grandTotalCurrency };

	const products = orderItemListRows.map((row) => ({
		item_id: row.parentProduct?.partNumber || row.details?.partNumber,
		item_name: row.product.name,
		coupon: 'N/A',
		discount: '0.00000',
		affiliation: 'Dportenis',
		item_brand: findProductAttribute(row.details.attributes, 'Marca')?.value,
		item_category: '',
		item_variant: row.product?.keyword,
		price: row.orderItemListRow.price.orderItemPrice,
		currency: 'MXN',
		quantity: 1,
		item_talla: findProductAttribute(row.details.attributes, 'Talla')?.value,
	}));

	return {
		cart,
		products,
		hcl_account,
		marketplaceStore: storeName,
	};
};
